<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_xi"><img alt="Image" height="233" src="images/1.jpg" width="350"/></a></p><a id="page_xi">
<p class="noindent">You’ve packed up all your belongings: clothes, bedding, your music, perhaps a computer and a few family photos. Now you are moving out of your parents’ house and into your own place—maybe an apartment or a dorm room or house. You’re ready. So ready. At least you think so. You certainly want to be. That’s where this book comes in. This guide was created to equip you not merely for surviving on your own but for thriving—successfully entering and navigating the world of adulthood. With God’s grace, you can do just that.</p>
<p class="indent"><span class="txit">Essential Survival Guide</span> touches on almost every aspect of day-to-day life. Whether you’re doing your first load of laundry, balancing your checkbook, or selecting a church, this book offers guidance and suggestions for you to consider in your decision-making process. Let the adventure begin!</p>
</a><p><a id="page_xi"></a><a id="page_xii"></a></p><a id="page_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?129fd414